import { ErrorCode, ResponceDataType } from "../../../../ErrorCode";

/**
 *ストレージ容量設定
 */
export type FILE_STORAGE_PERIOD = {
  SAV_INDEX: number;
  FREE_SPACE: number;
  FILE_RET_PERIOD: number;

  /// 編集フラグ
  isEdit: boolean;
}
/**
 *　デフォルトデータ作成
 * @returns
 */
export const CreateFILE_STORAGE_PERIOD = () : FILE_STORAGE_PERIOD => {
  let ret: FILE_STORAGE_PERIOD = {
    SAV_INDEX: 0,
    FREE_SPACE: 1,
    FILE_RET_PERIOD: 1,
    isEdit : false,
  };
  return ret;
}

/**
 * ストレージ設定取得
 * @returns
 */
export const GetStorageCapacitySetting = (): Promise<FILE_STORAGE_PERIOD> => {
  console.debug(["api/StorageCapacitySetting/ get go"]);
  return new Promise((resolve, reject) => {
    fetch("api/StorageCapacitySetting/", {
      method: 'GET',
      headers: { pageName: 'StorageCapacitySettingPage' },
    })
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: FILE_STORAGE_PERIOD) => {
        if (result != null) {
          //編集フラグ初期化
          result.isEdit = false;
          console.debug(["api/StorageCapacitySetting/ get ok ", result]);
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      })
  })
};



/**
 * ストレージ設定更新
 * @returns
 */
export const PutStorageCapacitySetting = (settings : FILE_STORAGE_PERIOD): Promise<ResponceDataType> => {
  console.debug(["api/StorageCapacitySetting/ put go","params",settings]);
  return new Promise((resolve, reject) => {
    fetch("api/StorageCapacitySetting/", {
      method: "put",
      headers: {
        'Content-Type': 'application/json',
         pageName: 'StorageCapacitySettingPage'
      },
      body: JSON.stringify(settings)
    }).then((res) => {
      if (!res.ok) {
        let message = `データが見つかりませんでした status:${res.status}`;
        reject(message);
      }
      return res.json();
    }).then((result: ResponceDataType) => {
      console.debug(["api/StorageCapacitySetting/ put ok", "result", result]);
      resolve(result);
    },
      (error) => {
        console.debug(["api/StorageCapacitySetting/ put errro","params",settings]);
        console.error(error);
        reject(error);
      })
  });
}


/**
 * 編集チェック
 */
export const CheckStorageCapacitySetting = (targetModel: FILE_STORAGE_PERIOD): boolean => {
  return targetModel.isEdit;
};
